import BoxIcon from "../../../../components/ui/box-icon/box-icon";
import imgInnovation from "../../../../assets/images/about-innovation.jpeg";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";

import "./about-innovation.scss";
import { Fade } from "react-awesome-reveal";

const AboutInnovation = () => {
  const device = useBreakpoint();
  const isMobile = device === "mobile" || device === "tablet";
  return (
    <section className="about-innovation">
      {!isMobile && (
        <div className="about-innovation__img-section">
          <Fade direction="left" duration={900} triggerOnce>
            <img
              className="about-innovation__img"
              src={imgInnovation}
              alt="Innovazione e brevetti sui pali rotoinfissi"
            />
          </Fade>
        </div>
      )}
      <div className="about-innovation__info-section">
        <Fade
          direction={!isMobile ? "right" : "up"}
          duration={900}
          delay={200}
          triggerOnce
        >
          <div className="about-innovation__icon">
            <BoxIcon icon={"calendar"} size={"medium"} type={"secondary"} />
          </div>
          <h2 className="about-innovation__title">
            Innovazione e Brevetti (2000)
          </h2>
          <div className="about-innovation__text-container">
            <p className="about-innovation__text">
              Al primo brevetto, ne seguì un secondo negli anni 2000, con il
              quale il titolare portò le Costruzioni Generali a specializzarsi
              nella formazione di Pali Rotoinfissi.
            </p>
            <p className="about-innovation__text">
              La lavorazione è particolare e molto richiesta, in quanto la
              formazione dei pali avviene senza vibrazioni né asportazione di
              materiale di risulta, con fondello a perdere brevettato.
            </p>
            <p className="about-innovation__text about-innovation__text--highlighted">
              Tecnologia praticabile su qualsiasi tipo di terreno vegetale, con
              diametro dei pali che varia dai 15 ai 40 cm.
            </p>
          </div>
        </Fade>
      </div>
      {!!isMobile && (
        <div className="about-innovation__img-section">
          <Fade direction="up" duration={700} triggerOnce>
            <img
              className="about-innovation__img"
              src={imgInnovation}
              alt="Innovazione e brevetti sui pali rotoinfissi"
            />
          </Fade>
        </div>
      )}
    </section>
  );
};

export default AboutInnovation;
